
import React from 'react';
export default class Loading extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render(){
        const _this = this;
        return (
            <div className="loading-anim">
                <div className="border out"></div>
                <div className="border in"></div>
                <div className="border mid"></div>
            </div>
        );
    }
}
